import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './DisputeManager.css';

import backIcon from '../../assets/backspace-icon.png';
import dotsIcon from '../../assets/dots-hori-icon.png';

function DisputeManager({ user }) {
  const [disputes, setDisputes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('pending'); // 'pending' | 'resolved'
  const navigate = useNavigate();

  const fetchDisputes = async () => {
    try {
      const res = await api.get('/admin/disputes');
      console.log('📦 Admin Disputes Response:', res.data);
      setDisputes(res.data.disputes || []);
    } catch (err) {
      console.error('❌ Failed to fetch disputes:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDisputes();
  }, [statusFilter]);

  const filteredDisputes = disputes.filter((d) => {
    const isResolved = d.status === 'completed' || d.status === 'cancelled' || d.status === 'resolved';
    return statusFilter === 'pending' ? !isResolved : isResolved;
  });

  const resolveDispute = async (disputeId, decision) => {
    try {
      const response = await api.patch(`/admin/disputes/${disputeId}/resolve`, { decision });
      console.log('📣 Admin resolving dispute', response.data);
      fetchDisputes();
    } catch (err) {
      console.error('❌ Failed to resolve dispute:', err);
    }
  };

  return (
    <div className="dispute-container">
      <div className="dispute-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="dispute-back-icon"
          onClick={() => navigate('/admin')}
        />
        <h2>Escrow Disputes</h2>
      </div>

      <div className="dispute-filters">
        <button
          className={statusFilter === 'pending' ? 'pending-active' : 'pending'}
          onClick={() => setStatusFilter('pending')}
        >
          Pending
        </button>
        <button
          className={statusFilter === 'resolved' ? 'resolved-active' : 'resolved'}
          onClick={() => setStatusFilter('resolved')}
        >
          Resolved
        </button>
      </div>

      <div className="dispute-content">
        {loading ? (
          <div className="dispute-loading">Loading disputes...</div>
        ) : filteredDisputes.length === 0 ? (
          <div className="no-disputes">✅ No {statusFilter} disputes at the moment.</div>
        ) : (
          <div className="dispute-section">
            <h3>{statusFilter === 'pending' ? 'Pending Disputes' : 'Resolved Disputes'}</h3>
            {filteredDisputes.map((d) => {
              const disputeStatus =
                d.status === 'completed' || d.status === 'cancelled' || d.status === 'resolved'
                  ? 'resolved'
                  : 'pending';

              return (
                <div className="dispute-card-wrapper" key={d._id}>
                  <div
                    className="dispute-card"
                    onClick={() => navigate(`/admin/disputes/${d._id}`)}
                  >

<p className="dispute-id">
  🧾 Order: {d.orderId ? d.orderId.slice(-6).toUpperCase() : 'N/A'}
</p>

                    <p><strong>Buyer:</strong> {d.buyer}</p>
                    <p><strong>Seller:</strong> {d.seller}</p>
                    <p>
                      <strong>Status:</strong>{' '}
                      <span className={`dispute-status ${disputeStatus}`}>
                        {disputeStatus}
                      </span>
                    </p>
                    <p><strong>Opened:</strong> {new Date(d.createdAt).toLocaleString()}</p>
                  </div>



{disputeStatus === 'resolved' && d.orderId && (
  <img
    src={dotsIcon}
    alt="View Decision"
    className="dispute-dots-icon"
    onClick={(e) => {
      e.stopPropagation(); // Prevent card click
      console.log('🧭 Navigating to DisputeDecisionScreen for order:', d.orderId);
      navigate(`/dispute-decision/${d.orderId}`);
    }}
  />
)}




                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default DisputeManager;
